import React, { Fragment, Component } from 'react';

import './index.css';
import { autoClickPreferences } from '../../../library/constants';

export class Tabs extends Component {

  canClickTab = true;
  tabStyle = {
        position: 'relative',
        float: 'left',
        top: '-18px',
        width: '100px',
        height: `25px`,
        background: '#EFEFEF',
        opacity: 1,
        borderRadius: '5px 5px 0px 0px',
        cursor: 'pointer',
        textAlign: 'center',
        color: 'gray',
        borderTop: '1px solid lightgray',
        borderLeft: '1px solid lightgray',
        borderRight: '1px solid lightgray',
        fontSize: '15px',
        lineHeight: '16px',
        paddingTop: '2px',
  }

  componentDidMount(){
  }

  componentDidUpdate(){
  }

  render () {

   return (
      <Fragment>
        <div
          style={{
            width: `${( autoClickPreferences ? 320: 220)}px`,
            height: `${0}px`,
            margin: '-20px auto 0px',
        }}>
                {

                      this.props.chartType !== 'fan'

                      ?

                          <Fragment>

                                    <div
                                      id="treeGenerations"
                                      style={this.tabStyle}
                                      className={`tabPref${( this.props.activeTab === 'tree' ? ' activiated': '')}`}
                                      onClick={
                                        ()=>{
                                          this.props.setActiveTab('tree');
                                        }
                                      }
                                      onMouseOver={
                                        ()=>{

                                        }
                                      }
                                      onMouseOut={
                                        ()=>{

                                        }
                                      }
                                    >{ typeof(window.trl) !== 'undefined' ? window.trl('View'): 'View' }
                                    </div>
                                    <div
                                      id="nodeCustomization"
                                      className={`tabPref${( this.props.activeTab  === 'custom' ? ' activiated': '')}`}
                                      style={this.tabStyle}
                                      onClick={
                                        ()=>{
                                          this.props.setActiveTab('custom');
                                        }
                                      }
                                      onMouseOver={
                                        ()=>{
                                        }
                                      }
                                      onMouseOut={
                                        ()=>{
                                        }
                                      }
                                    >{ typeof(window.trl) !== 'undefined' ? window.trl('Customize'): 'Customize' }
                                    </div>

                          </Fragment>

                      :

                      null

                }

                          {
                            autoClickPreferences

                            ?

                                <div
                                  id="optionsTab"
                                  className={`tabPref${( this.props.activeTab  === 'options' ? ' activiated': '')}`}
                                  style={this.tabStyle}
                                  onClick={
                                    ()=>{
                                      this.props.setActiveTab('options');
                                    }
                                  }
                                  onMouseOver={
                                    ()=>{
                                    }
                                  }
                                  onMouseOut={
                                    ()=>{
                                    }
                                  }
                                >{ typeof(window.trl) !== 'undefined' ? window.trl('Options'): 'Options' }
                                </div>

                            :

                            null
                          }
        </div>
      </Fragment>
    );
  }
}

